import { createAsyncThunk } from "@reduxjs/toolkit";

import { parseApiError, ParsedApiError, postBatterySizerRecommendations } from "@/lib/api/proposal-api";
import { type RootState } from "@/rootReducer";

import { BatterySizerResponse, BatterySizerSettings } from "./battery-sizer.types";

export const fetchBatterySizerRecommendations = createAsyncThunk<
  BatterySizerResponse,
  BatterySizerSettings,
  { state: RootState; rejectValue: ParsedApiError }
>("data/fetchBatterySizerRecommendations", async (payload, thunkAPI) => {
  try {
    const { reportHash } = thunkAPI.getState().proposal;
    const response = await postBatterySizerRecommendations(reportHash, payload);
    return response.data;
  } catch (e: any) {
    return thunkAPI.rejectWithValue(parseApiError(e));
  }
});
